import { ArrowUpRight, Globe } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';

import { getLandingUrl } from '../lib/urls';

import { navigationCategories } from './navigation';

export function Sidebar() {
  const location = useLocation();
  const { t } = useTranslation();

  return (
    <aside className="fixed inset-y-0 left-0 z-50 hidden w-[var(--sidebar-width)] border-r border-border/80 bg-[hsl(var(--surface-subtle)/0.92)] lg:flex lg:flex-col">
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_20%_0%,hsl(var(--primary)/0.16),transparent_16rem)]" />
      <div className="relative flex h-[var(--topbar-height)] shrink-0 items-center border-b border-border/70 px-5">
        <Link to="/dashboard" className="group flex items-center gap-3 rounded-xl focus-visible:outline-none">
          <img src="/logo.png" alt="SUSCRI.net" className="h-9 w-auto" />
          <span className="sr-only">{t('Ir al panel')}</span>
        </Link>
      </div>

      <nav aria-label={t('Navegación principal')} className="scrollbar-subtle relative flex-1 overflow-y-auto px-1 pb-4 pt-2">
        {navigationCategories.map(category => (
          <div key={category.name} className="mb-2">
            <div className="nav-category">{t(category.name)}</div>
            <ul role="list" className="space-y-1">
              {category.items.map(item => {
                const isActive = location.pathname === item.href;
                return (
                  <li key={item.name}>
                    <Link
                      to={item.href}
                      aria-current={isActive ? 'page' : undefined}
                      className={isActive ? 'nav-item-active' : 'nav-item'}
                    >
                      <item.icon className="h-[1.15rem] w-[1.15rem] shrink-0" aria-hidden="true" />
                      <span className="truncate">{t(item.name)}</span>
                    </Link>
                  </li>
                );
              })}
            </ul>
          </div>
        ))}
      </nav>

      <div className="relative border-t border-border/70 p-3">
        <a
          href={getLandingUrl()}
          className="group flex items-center gap-3 rounded-xl border border-border bg-card/60 p-3 text-sm text-muted-foreground transition hover:border-primary/30 hover:bg-accent hover:text-foreground"
        >
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary/10 text-primary">
            <Globe className="h-[1.1rem] w-[1.1rem]" aria-hidden="true" />
          </span>
          <span className="min-w-0 flex-1">
            <span className="block font-medium text-foreground">SUSCRI.net</span>
            <span className="block truncate text-xs">{t('Página principal')}</span>
          </span>
          <ArrowUpRight className="h-4 w-4 transition group-hover:-translate-y-0.5 group-hover:translate-x-0.5" aria-hidden="true" />
        </a>
      </div>
    </aside>
  );
}
